import React from "react";

import { Card, CardContent, Typography } from "@mui/material";

const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
};

const SquareFootageCard = ({ projectData }) => {
    const squareFootage = projectData?.project_data?.square_feet || projectData?.square_feet || '--'


return (
    <div>
        {projectData && Object.keys(projectData).length > 0 ? (
            <Typography style={{ textAlign:'center'}}variant="body1" className='main-key-project-info-body'>
                {formatNumber(squareFootage) + " SF" || '--'}</Typography>
        ) : (
            <Typography style={{textAlign: 'center'}}className="main-key-project-info-body">--</Typography>
        )}
    </div>
    );
}

export default SquareFootageCard;